import { render } from "./PRSummary.vue?vue&type=template&id=1dc1b9e5"
import script from "./PRSummary.vue?vue&type=script&lang=js"
export * from "./PRSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__